var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]:not(.keep)').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.products = {
	init: function() {
		$('#select--type, #select--material, #select--system').on('change', site.products.updateVisibility);
	},

	updateVisibility: function() {
		var $cards = $('.category .card');
		$cards.each(function() {
			$(this).hide();
		});

		var $selectorMaterial = $('#select--material').val();
		var $selectorType = $('#select--type').val();
		var $selectorSystem = $('#select--system').val();

		var $cardsToShow = $cards;

		if ($selectorMaterial !== 'all' && $selectorType !== 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function() {
				return $(this).is('.' + $selectorMaterial) && $(this).is('.' + $selectorType) && $(this).is('.' + $selectorSystem);
			});
		} else if ($selectorMaterial === 'all' && $selectorType !== 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function() {
				return $(this).is('.' + $selectorType) && $(this).is('.' + $selectorSystem);
			});
		} else if ($selectorMaterial !== 'all' && $selectorType === 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function() {
				return $(this).is('.' + $selectorMaterial) && $(this).is('.' + $selectorSystem);
			});
		} else if ($selectorMaterial !== 'all' && $selectorType !== 'all' && $selectorSystem === 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorMaterial) && $(this).is('.' + $selectorType);
			});
		} else if ($selectorMaterial !== 'all' && $selectorType === 'all' && $selectorSystem === 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorMaterial);
			});
		} else if ($selectorMaterial === 'all' && $selectorType !== 'all' && $selectorSystem === 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorType);
			});
		} else if ($selectorMaterial === 'all' && $selectorType === 'all' && $selectorSystem !== 'all') {
			$cardsToShow = $cards.filter(function () {
				return $(this).is('.' + $selectorSystem);
			});
		}



		$cardsToShow.each(function() {
			$(this).show();
		});
	}
};

site.categoryFilter = {
	init: function() {
		$('.category__wrap').on('click', 'button', site.categoryFilter.updateCategory);
	},

	updateCategory: function () {
		var $cat = $('.category');
		$cat.each(function() {
			$(this).hide();
		});

		var $categorySelected = $(this).val();
		var $catToShow = $cat;

		if ($categorySelected === 'fasteignir') {
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else if ($categorySelected === 'skip-og-batar'){
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else if ($categorySelected === 'fyrirtaeki'){
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else if ($categorySelected === 'velar-og-veidarfaeri'){
			$catToShow = $cat.filter(function () {
				return $(this).is('.' + $categorySelected);
			})
		}
		else {
			$catToShow = $cat.filter(function () {
				return $(this).is('.skip-og-batar');
			})
		}

		$catToShow.each(function() {
			$(this).show();
		});

	}
};


site.frontpage = {
	init: function() {
		site.frontpage.scroll();
		site.frontpage.carousel();
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	},

	carousel: function () {
		const carouselConfig = {
			items: 4,
			dots: false,
			nav: true,
			margin: 30,
			responsive: {
				0: {
					margin: 20,
					items: 1,
				},
				767: {
					items: 2,
				},
				990: {
					items: 3,
				},
				1200: {
					items: 4,
				},
			},
		};
		site.owl.init('#main .box_aitems.carousel #promo ul', carouselConfig);
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]:not(".res")', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
